/* Cover studio: a real-time spa cover dressed in the actual swatch photographs,
   plus the materials & colours viewer that feeds the HST builder.
   The 3D object is illustrative; dimensions and ordering stay in the builder. */
import {THREE,createStudio,loadSpa,outline,photoTexture,photoTextureReady} from './pbspa-spa-stage.js';

const root=document.querySelector('.lx-studio');
if(root)init();

function init(){
const D=window.PB_HT?.cover,A=window.PB_HT?.__imgs||{};if(!D)return;
const colours=D.colours.map((c,i)=>({...c,index:i,thumb:A[c.file.replace('.webp','-t.webp')]||A[c.file],full:A[c.file]}));
const groups=[...new Set(colours.map(c=>c.material))];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const $=s=>root.querySelector(s),$$=s=>[...root.querySelectorAll(s)];
const notes={'Spa Cover Vinyl':'Our core cover vinyl in fourteen colours, with a supple, leather-grain surface.','Specialty Vinyl':'Embossed specialty patterns for a more architectural, tailored look.','Pro-Tex':'A woven-look technical finish with a fine, matte texture.'};

// ---------------------------------------------------------------- viewer UI
const groupBar=$('.lx-materials__groups'),grid=$('.lx-materials__grid'),loupe=$('.lx-loupe'),loupeImg=$('.lx-loupe__img');
let selected=colours.find(c=>c.name==='Charcoal'&&c.material==='Spa Cover Vinyl')||colours[0],group=selected.material;
groups.forEach((g,i)=>{const b=document.createElement('button');b.type='button';b.role='tab';b.textContent=g;b.dataset.group=g;b.setAttribute('aria-selected',String(i===0));b.innerHTML=`${g}<small>${colours.filter(c=>c.material===g).length}</small>`;b.addEventListener('click',()=>showGroup(g,true));groupBar.append(b);});
function showGroup(g,pickFirst){group=g;$$('[data-group]').forEach(b=>b.setAttribute('aria-selected',String(b.dataset.group===g)));grid.replaceChildren(...colours.filter(c=>c.material===g).map(c=>{const b=document.createElement('button');b.type='button';b.role='radio';b.className='lx-swatch';b.dataset.index=c.index;b.setAttribute('aria-checked',String(c===selected));b.setAttribute('aria-label',`${c.name}, ${c.material}`);b.innerHTML=`<img src="${c.thumb}" alt="" width="240" height="180" loading="lazy"><span>${c.name}</span>`;b.addEventListener('click',()=>select(c));return b;}));if(pickFirst&&selected.material!==g)select(colours.find(c=>c.material===g));}
function select(c){selected=c;$$('.lx-swatch').forEach(b=>b.setAttribute('aria-checked',String(+b.dataset.index===c.index)));loupeImg.src=c.full;loupeImg.alt=`${c.name} ${c.material} swatch photograph`;loupe.style.setProperty('--loupe',`url("${c.full}")`);$('.lx-materials__material').textContent=c.material;$('.lx-materials__name').textContent=c.name;$('.lx-materials__note').textContent=notes[c.material]||'';stage.setFinish(c);}
grid.addEventListener('keydown',e=>{const items=$$('.lx-swatch'),i=items.indexOf(document.activeElement);if(i<0)return;const step={ArrowRight:1,ArrowDown:1,ArrowLeft:-1,ArrowUp:-1}[e.key];if(!step)return;e.preventDefault();const n=items[(i+step+items.length)%items.length];n.focus();n.click();});

// Loupe: a raking-light magnifier over the actual swatch photograph.
const moveLens=(x,y)=>{loupe.style.setProperty('--lx',x);loupe.style.setProperty('--ly',y);};
loupe.addEventListener('pointermove',e=>{const r=loupe.getBoundingClientRect();loupe.classList.add('is-looking');moveLens((e.clientX-r.left)/r.width,(e.clientY-r.top)/r.height);});
loupe.addEventListener('pointerleave',()=>loupe.classList.remove('is-looking'));
let lx=.5,ly=.5;loupe.addEventListener('keydown',e=>{const d={ArrowLeft:[-.05,0],ArrowRight:[.05,0],ArrowUp:[0,-.05],ArrowDown:[0,.05]}[e.key];if(!d)return;e.preventDefault();lx=Math.min(1,Math.max(0,lx+d[0]));ly=Math.min(1,Math.max(0,ly+d[1]));loupe.classList.add('is-looking');moveLens(lx,ly);});
loupe.addEventListener('blur',()=>loupe.classList.remove('is-looking'));

// Your spa: the four Equinox models this department sells drive the preview's footprint.
const models=(window.PB_HT?.models||[]);
const modelBar=$('.lx-materials__models');let model=models.find(m=>m.code==='743L-230')||models[0];
if(modelBar&&models.length){modelBar.replaceChildren(...models.map(m=>{const b=document.createElement('button');b.type='button';b.role='radio';b.dataset.model=m.code;b.setAttribute('aria-checked',String(m===model));
 b.dataset.modelLabel=`${m.name} ${m.variant}`;b.innerHTML=`<strong>${m.name.replace('Equinox ','')}</strong><span>${m.variant.replace(' · Plug & Play','')}</span>`;
 b.addEventListener('click',()=>setModel(m));return b;}));}
function setModel(m){model=m;$$('[data-model]').forEach(b=>b.setAttribute('aria-checked',String(b.dataset.model===m.code)));
 const metres=(v)=>(v*.0254).toFixed(2);
 const note=$('.lx-materials__fit');if(note)note.textContent=`${m.name} ${m.variant} · ${metres(m.dims.w)} × ${metres(m.dims.l)} m · ${m.seatsLabel} · ${m.jets} jets`;
 stage.setModel(m);}

// Shape + opening
$$('[data-lx-shape]').forEach(b=>b.addEventListener('click',()=>{$$('[data-lx-shape]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));stage.setShape(b.dataset.lxShape);}));
const open=$('#lx-cover-open');open.addEventListener('input',()=>{stage.setOpen(open.value/100);open.setAttribute('aria-valuetext',open.value==='0'?'Closed':open.value==='100'?'Folded open':open.value+'% open');});

let handOpen=false;open.addEventListener('pointerdown',()=>handOpen=true);open.addEventListener('keydown',()=>handOpen=true);
const mats=$('#cover-materials');if(!reduce)addEventListener('scroll',()=>{if(handOpen)return;const r=mats.getBoundingClientRect(),p=Math.min(1,Math.max(0,1-r.top/innerHeight));const v=Math.round(p*38);if(+open.value!==v){open.value=v;stage.setOpen(v/100,true);}},{passive:true});

// Hand the choice to the real builder (same radios the HST configurator reads).
$('.lx-materials__use').addEventListener('click',()=>{const form=document.querySelector('#cover-builder form')||document;
 const brand=form.querySelector?.('[name=brand]'),modelField=form.querySelector?.('[name=model]');
 if(brand&&!brand.value)brand.value='Equinox';
 if(modelField&&model){modelField.value=model.name.replace('Equinox ','')+' ('+model.variant.replace(' · Plug & Play','')+')';modelField.dispatchEvent(new Event('input',{bubbles:true}));}
 if(brand)brand.dispatchEvent(new Event('input',{bubbles:true}));const colour=form.querySelector(`[name=colour][value="${selected.index}"]`);if(colour){colour.checked=true;colour.dispatchEvent(new Event('change',{bubbles:true}));}const shape=$('[data-lx-shape][aria-pressed="true"]')?.dataset.lxShape;const radio=shape&&form.querySelector(`[name=shape][value="${shape}"]`);if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}document.querySelector('#cover-builder')?.scrollIntoView({behavior:reduce?'auto':'smooth'});});

// ---------------------------------------------------------------- 3D stage
const stage=createStage($('.lx-studio__canvas'),reduce);
if(!stage.ok)root.classList.add('is-static');
showGroup(group,false);select(selected);if(models.length)setModel(model);
/* Once the stage is up, quietly fetch the photographs for the rest of the
   swatches on show, so the next colour the visitor tries is already in hand. */
stage.warm&&stage.warm(colours.filter(c=>c.material===group));
}

function createStage(canvas,reduce){
const studio=createStudio(canvas);
if(!studio)return {ok:false,setFinish(){},setShape(){},setOpen(){},setModel(){}};
const {renderer,scene,camera}=studio;

// Spa body comes from the shared stage builder; the cover is this viewer's own work.
const turntable=new THREE.Group();scene.add(turntable);
const vinyl=new THREE.MeshStandardMaterial({color:0xffffff,roughness:.5,metalness:0,bumpScale:2.2});
const strapMat=new THREE.MeshStandardMaterial({color:0x151618,roughness:.7});
let parts=[],hinge,coverGroup,spaBody=null,interiorMap=null,modelCode='743L-230',shape='rounded',openTarget=0,openNow=0;
// Footprint comes from the selected Equinox model (catalogue inches -> metres).
let W=2.24,D=2.24,H=.46;const T0=.13,T1=.065;
/* A fitted cover is cut a little larger than the shell and its skirt drops over
   the rim, so the closed cover hides the spa's top edge instead of stopping
   short of it and letting the walls show through. */
/* 50 mm oversize: the acrylic lip rolls 21 mm past the footprint on each
   side, and the skirt has to drop over it, not through it. */
const OVER=.05;
/* Where the cover's underside rests. The catalogue height is the spa's overall
   height; the model's own rim sits a shade lower, so once it loads we take the
   measurement from the geometry and stop guessing. */
let rimY=null;

function clearParts(){for(const p of parts){turntable.remove(p);p.traverse(o=>o.geometry?.dispose());}parts=[];}

/* The spa under the cover is loaded once per model and kept. Rebuilding the
   cover — a different shape, a different fold — must never take the spa away
   and fetch it again: that is what left a cover hanging over an empty deck. */
const spas=new Map();
function ensureSpa(){
 const want=modelCode;
 if(spas.has(want))return spas.get(want);
 const p=loadSpa({code:want,W,D,H,renderer,base:window.PB_ASSET_BASE||'assets/',withWater:false}).catch(()=>null);
 spas.set(want,p);
 return p;
}
function showSpa(){
 const want=modelCode;
 return ensureSpa().then(g=>{
  if(!g||want!==modelCode)return null;
  if(spaBody&&spaBody!==g)turntable.remove(spaBody);
  spaBody=g;turntable.add(g);
  if(g.userData&&g.userData.rimY){rimY=g.userData.rimY;seat();}
  /* Hidden, never unloaded: switching back to a shape the tub suits is a
     visibility flag on the next frame rather than a fetch and a rebuild. */
  g.visible=!solo();
  request();
  return g;
 });
}

function build(kind){clearParts();
 // Cover halves: tapered from the centre fold to the outer edge, with a skirt.
 const half=side=>{const g=new THREE.ExtrudeGeometry(halfOutline(kind,side),{depth:T0,bevelEnabled:true,bevelSize:.018,bevelThickness:.018,bevelSegments:4,curveSegments:32,UVGenerator:planarUV});g.rotateX(-Math.PI/2);const pos=g.attributes.position;for(let i=0;i<pos.count;i++){const y=pos.getY(i);if(y>T0*.5){const t=Math.min(1,Math.abs(pos.getZ(i))/(D/2));pos.setY(i,y-(T0-T1)*t);}}g.computeVertexNormals();const m=new THREE.Mesh(g,vinyl);m.castShadow=m.receiveShadow=true;return m;};
 const halfA=half(1),halfB=half(-1);
 const skirtShape=outline(kind,W+OVER+.04,D+OVER+.04,.37);skirtShape.holes.push(new THREE.Path(outline(kind,W+OVER,D+OVER,.35).getPoints(64)));
 const skirt=new THREE.Mesh(new THREE.ExtrudeGeometry(skirtShape,{depth:.09,bevelEnabled:false,curveSegments:24}),vinyl);skirt.rotation.x=-Math.PI/2;skirt.position.set(0,-.09,D/2);skirt.castShadow=true;
 halfA.position.z=.008;halfB.position.z=-.008;
 // The cover folds in half, then the folded stack lifts and tilts back off the spa,
 // the way a cover lifter works — which is what actually reveals the shell.
 const coverRoot=new THREE.Group();coverRoot.position.set(0,coverY(),-D/2);coverGroup=coverRoot;
 const coverA=new THREE.Group();coverA.add(halfA);coverA.position.z=D/2;
 const strap=x=>{const m=new THREE.Mesh(new THREE.BoxGeometry(.06,.14,.012),strapMat);m.position.set(x,-.05,D+.04);m.castShadow=true;return m;};
 hinge=new THREE.Group();hinge.position.set(0,T0,D/2);const coverB=new THREE.Group();coverB.add(halfB);coverB.position.y=-T0;hinge.add(coverB);
 coverRoot.add(coverA,hinge,skirt);
 if(kind!=='round'){coverRoot.add(strap(-W*.25),strap(W*.25));}
 parts=[coverRoot];parts.forEach(p=>turntable.add(p));}
/* Underside of the closed cover: the rim, plus the bevel the extrusion hangs
   below its own origin, plus 18 mm — the tallest thing on the deck is the
   S-handle air control at 16 mm, and the TP500S bezel stands 13.5 mm. */
/* A cover cut square, or cut round, does not belong on an Equinox shell: the
   shell's corners are radiused, so a 90 degree cover overhangs its corners and
   a round one cuts across them. Showing either sitting on the tub is a picture
   of a cover that does not fit. For those two the tub steps out and the cover
   is shown on its own — centred, at the same scale, complete. Every other
   shape is a cover this spa can actually wear, so the tub stays. */
const COVER_ONLY=new Set(['square','round']);
const solo=()=>COVER_ONLY.has(shape);
function coverY(){return solo()?.12:(rimY!==null?rimY:H-.02)+.018+.018;}
function seat(){if(coverGroup)coverGroup.position.y=coverY();}
// Exact half outlines in the XY plane (front half y<0). After rotateX(-90°) shape y becomes −z.
function halfOutline(kind,side){const s=new THREE.Shape(),w=W+OVER,d=D+OVER,x=-w/2,y=-d/2;
 if(kind==='round'){if(side>0)s.absarc(0,0,w/2,Math.PI,Math.PI*2,false);else s.absarc(0,0,w/2,0,Math.PI,false);s.closePath();return s;}
 const r=kind==='square'?.02:.34;
 if(side>0){s.moveTo(x,0);s.lineTo(x,y+r);s.quadraticCurveTo(x,y,x+r,y);s.lineTo(x+w-r,y);s.quadraticCurveTo(x+w,y,x+w,y+r);s.lineTo(x+w,0);}
 else{s.moveTo(x+w,0);s.lineTo(x+w,-y-r);s.quadraticCurveTo(x+w,-y,x+w-r,-y);s.lineTo(x+r,-y);s.quadraticCurveTo(x,-y,x,-y-r);s.lineTo(x,0);}
 s.closePath();return s;}
const planarUV={generateTopUV:(g,v,a,b,c)=>[a,b,c].map(i=>new THREE.Vector2(v[i*3]*.9,v[i*3+1]*.9)),generateSideWallUV:(g,v,a,b,c,d)=>[a,b,c,d].map(i=>new THREE.Vector2((v[i*3]+v[i*3+1])*.9,v[i*3+2]*.9))};

function finishTexture(url){const t=photoTexture(url,renderer);t.wrapS=t.wrapT=THREE.MirroredRepeatWrapping;return t;}
/* Swapping a finish waits for the photograph to arrive and then changes the
   material in one go. Assigning a texture that is still downloading is what
   turned the cover black between selections, and with several selections in
   flight only the newest may land. */
let finishToken=0;
function setFinish(c){
 const token=++finishToken;
 const apply=t=>{
  if(token!==finishToken)return;                  // a later choice already won
  const b=t.clone();b.colorSpace=THREE.NoColorSpace;b.wrapS=b.wrapT=THREE.MirroredRepeatWrapping;b.needsUpdate=true;
  vinyl.map=t;vinyl.bumpMap=b;
  vinyl.roughness=c.material==='Pro-Tex'?.86:c.material==='Specialty Vinyl'?.55:.5;
  vinyl.needsUpdate=true;
  root.dataset.finish=c.name;                     // what the cover is actually wearing
  request();
 };
 const t=finishTexture(c.full);
 if(t.image&&t.image.width)apply(t);              // already in: no wait at all
 else photoTextureReady(c.full,renderer).then(apply);
}
/* The rest of the swatches in view, warmed while nothing else is happening, so
   the next choice is already in hand. */
function warmFinishes(list){
 const idle=fn=>'requestIdleCallback' in window?requestIdleCallback(fn,{timeout:5000}):setTimeout(fn,900);
 const q=[...list];
 const next=()=>{const c=q.shift();if(!c)return;photoTextureReady(c.full,renderer).then(()=>idle(next));};
 idle(next);
}

// Interaction: drag to turn with inertia; idle drift until the visitor takes over.
let yaw=-.62,vel=0,dragging=false,lastX=0,idle=!reduce,pitch=.58,dist=5.9;
canvas.addEventListener('pointerdown',e=>{dragging=true;idle=false;lastX=e.clientX;canvas.setPointerCapture(e.pointerId);root.classList.add('is-dragged');});
canvas.addEventListener('pointermove',e=>{if(!dragging)return;const dx=e.clientX-lastX;lastX=e.clientX;vel=dx*.006;yaw+=vel;request();});
const end=()=>{dragging=false;};canvas.addEventListener('pointerup',end);canvas.addEventListener('pointercancel',end);
canvas.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){yaw+=e.key==='ArrowLeft'?-.2:.2;idle=false;request();}});

function resize(){const r=canvas.getBoundingClientRect();if(!r.width)return;renderer.setSize(r.width,r.height,false);camera.aspect=r.width/r.height;camera.fov=camera.aspect<1?42:30;camera.updateProjectionMatrix();request();}
let raf=0,visible=true,t0=performance.now(),aim=.36;
function request(){if(!raf&&visible)raf=requestAnimationFrame(render);}
function render(now){raf=0;const dt=Math.min(.05,(now-t0)/1000);t0=now;
 if(!dragging){yaw+=vel;vel*=.94;if(idle)yaw+=dt*.12;}
 openNow+=(openTarget-openNow)*(reduce?1:.12);
 const fold=Math.min(1,openNow/.55),lift=Math.max(0,(openNow-.55)/.45);
 if(hinge)hinge.rotation.x=fold*Math.PI*.97;
 if(coverGroup)coverGroup.rotation.x=-lift*1.12;
 turntable.rotation.y=yaw;
 /* On its own the cover is a smaller subject sitting lower, so the camera
    comes in and looks down a little rather than leaving it adrift. */
 const soloNow=solo();
 aim+=((soloNow?.16:.36)-aim)*(reduce?1:.12);
 const d=(camera.aspect<1?dist*1.35:dist)*(soloNow?.82:1);
 camera.position.set(0,Math.sin(pitch)*d,Math.cos(pitch)*d);camera.lookAt(0,aim,0);
 renderer.render(scene,camera);
 /* The spa and its cover are one object to the visitor, so the stage stays
    blank until both are in it and drawn together. A cover appearing first,
    hanging over nothing while the spa loads, reads as broken. */
 if(spaBody&&!root.classList.contains('is-ready'))root.classList.add('is-ready');
 if(idle||dragging||Math.abs(vel)>.0005||Math.abs(openTarget-openNow)>.001)request();}
new ResizeObserver(resize).observe(canvas);
new IntersectionObserver(([e])=>{visible=e.isIntersecting;if(visible)request();}).observe(canvas);
build(shape);showSpa();resize();request();
return {ok:true,setFinish,warm:warmFinishes,
 setShape(k){
  shape=k;build(k);seat();
  /* The tub is already built, so this is a flag, not a load: no black frame,
     no half-built scene, no wait. */
  if(spaBody)spaBody.visible=!solo();
  showSpa();request();
 },
 setModel(m){W=m.dims.w*.0254;D=m.dims.l*.0254;H=m.dims.h*.0254;modelCode=m.code;
  const url=window.PB_HT?.__imgs?.['lx-top-'+m.code+'.webp']||('assets/lx-top-'+m.code+'.webp');
  interiorMap=photoTexture(url,renderer);
  build(shape);showSpa();dist=5.9*(W/2.24);request();},setOpen(v,passive){openTarget=v;if(!passive)idle=false;request();}};
}

